import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Loader2, MessageSquareQuote } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Admin view of members' private answers to the daily Lumera verse story. */
const StoryAnswersAdminPanel = ({ language = 'en' }) => {
  const es = language === 'es';
  const [days, setDays] = useState(7);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    setRows(null);
    axios.get(`${BACKEND_URL}/api/community/stories/admin/answers?days=${days}`, { withCredentials: true })
      .then(({ data }) => setRows(data.answers || []))
      .catch(() => setRows([]));
  }, [days]);

  return (
    <Card data-testid="story-answers-admin">
      <CardHeader className="flex flex-row items-center justify-between gap-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <MessageSquareQuote className="h-5 w-5 text-amber-600" />
          {es ? 'Respuestas al versículo diario' : 'Daily verse answers'}
          {rows && <span className="text-sm font-normal text-muted-foreground">({rows.length})</span>}
        </CardTitle>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="rounded-md border bg-background px-2 py-1 text-sm" data-testid="story-answers-days">
          <option value={7}>{es ? 'Últimos 7 días' : 'Last 7 days'}</option>
          <option value={30}>{es ? 'Últimos 30 días' : 'Last 30 days'}</option>
        </select>
      </CardHeader>
      <CardContent className="space-y-3">
        {rows === null ? (
          <Loader2 className="mx-auto h-5 w-5 animate-spin text-muted-foreground" />
        ) : rows.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground" data-testid="story-answers-empty">
            {es ? 'Aún no hay respuestas.' : 'No answers yet.'}
          </p>
        ) : rows.map((r) => (
          <div key={r.id} className="rounded-xl border p-3" data-testid={`story-answer-${r.id}`}>
            <p className="text-sm">“{r.text}”</p>
            <p className="mt-1 text-xs text-muted-foreground">
              {r.name} · {r.verse_reference} · {r.date}
            </p>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default StoryAnswersAdminPanel;
